import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, ElementRef, AfterViewInit } from '@angular/core';
import { GoogleAnalyticsService } from '../../../_core/api/google-analytics.service';

@Component({
  selector: 'app-shared-buttons',
  templateUrl: './shared-buttons.component.html',
  styleUrls: ['./shared-buttons.component.scss'],
})
export class SharedButtonsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() shareLink: string;
  @Input() linkTitle: string = '';
  @Output() shareClicked = new EventEmitter<string>();

  includedSocialMedia: string[] = ['facebook', 'linkedin', 'twitter', 'copy'];
  private lastCopyClickTime = 0;
  private mutationObserver: MutationObserver | null = null;

  constructor(private googleAnalyticsService: GoogleAnalyticsService, private elementRef: ElementRef) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.setupMutationObserver();
  }

  ngOnDestroy(): void {
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
  }

  private setupMutationObserver(): void {
    // Set up mutation observer to watch for icon changes from link to check
    this.mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'ng-reflect-icon') {
          const target = mutation.target as HTMLElement;
          const newValue = target.getAttribute('ng-reflect-icon');
          const oldValue = mutation.oldValue;

          // Detect copy button click: icon changes from "fas,link" to "fas,check"
          if (oldValue === 'fas,link' && newValue === 'fas,check') {
            this.handleCopyClick();
          }
        }
      });
    });

    // Start observing the component for attribute changes
    this.mutationObserver.observe(this.elementRef.nativeElement, {
      attributes: true,
      attributeOldValue: true,
      subtree: true,
      attributeFilter: ['ng-reflect-icon'],
    });
  }

  onShareClick(platform: string): void {
    this.googleAnalyticsService.trackButtonClick('Share', 'Share', platform, this.shareLink);

    switch (platform) {
      case 'facebook':
        this.googleAnalyticsService.event('Facebook Share', 'Share', 'Facebook Share', this.shareLink);
        break;
      case 'linkedin':
        this.googleAnalyticsService.event('LinkedIn Share', 'Share', 'LinkedIn Share', this.shareLink);
        break;
      case 'twitter':
        this.googleAnalyticsService.event('X Share', 'Share', 'X Share', this.shareLink);
        break;
      default:
        this.googleAnalyticsService.event('Unknown Share', 'Share', platform, this.shareLink);
        break;
    }

    this.shareClicked.emit(platform);
  }

  onCopyClick(): void {
    this.handleCopyClick();
  }

  private handleCopyClick(): void {
    const now = Date.now();

    // Simple debouncing to prevent rapid duplicate events
    if (now - this.lastCopyClickTime < 300) {
      return;
    }

    this.lastCopyClickTime = now;

    // Track copy button click - let GA service handle queueing
    this.googleAnalyticsService.trackButtonClick('Share', 'Share', 'copy', this.shareLink);
    this.shareClicked.emit('copy');
  }
}
